import {Box, Colors, Icon} from '@dagster-io/ui-components';

import Card from '@/components/Card';
import DagsterPlusLogo from '@/components/DagsterPlusLogo';
import {BodyText, SmallHeading} from '@/components/Text';
import styles from '@/components/css/TryDagsterForFree.module.css';
import LogoBayer from '@/components/logos/LogoBayer';
import LogoBraves from '@/components/logos/LogoBraves';
import LogoFlexport from '@/components/logos/LogoFlexport';
import LogoShell from '@/components/logos/LogoShell';
import LogoTMagenta from '@/components/logos/LogoTMagenta';
import LogoVoxMedia from '@/components/logos/LogoVoxMedia';
import LogoWellfound from '@/components/logos/LogoWellfound';
import LogoWhatnot from '@/components/logos/LogoWhatnot';

export function TryDagsterForFree() {
  return (
    <Box flex={{direction: 'column', gap: 48, alignItems: 'center'}}>
      <Box style={{height: 40}} margin={{bottom: 16, top: 12}}>
        <DagsterPlusLogo height={40} />
      </Box>
      <Box flex={{direction: 'column', gap: 32, alignItems: 'flex-start'}} style={{width: '400px'}}>
        <BulletPoint
          title="Integrate your data stack with Python"
          description="Define, model, and test data assets across tools like Databricks, dbt, and Airbyte."
        />
        <BulletPoint
          title="Orchestrate your data assets"
          description="Schedule, run, and monitor pipelines via an intuitive, cloud-native platform."
        />
        <BulletPoint
          title="Observe your platform"
          description="View platform status, data quality, metadata, lineage, and cost through a single pane of glass."
        />
      </Box>
      <Card style={{width: '460px'}} flex={{direction: 'column', gap: 24, alignItems: 'center'}}>
        <SmallHeading>You&apos;re in good company</SmallHeading>
        <div className={styles.gridContainer}>
          <LogoBayer />
          <LogoFlexport />
          <LogoShell />
          <LogoVoxMedia />
          <LogoTMagenta />
          <LogoWellfound />
          <LogoBraves />
          <LogoWhatnot />
        </div>
      </Card>
    </Box>
  );
}

function BulletPoint({title, description}: {title: string; description: string}) {
  return (
    <Box flex={{direction: 'row', alignItems: 'flex-start', gap: 12}}>
      <Box margin={{top: 2}}>
        <Icon name="check_circle" color={Colors.accentBlue()} size={16} />
      </Box>
      <Box flex={{direction: 'column', gap: 8}}>
        <SmallHeading>{title}</SmallHeading>
        <BodyText>{description}</BodyText>
      </Box>
    </Box>
  );
}
